module.exports = __webpack_public_path__ + "media/images/donate-hero-9f94c3588bc11fa52a59f8ce3bc314fb.jpg";